import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  IconButton,
} from '@mui/material';
import {
  AddRounded,
  CloseRounded,
  ExpandMoreRounded,
} from '@mui/icons-material';
import { getNavbarPhoto, getStrapiStores } from 'services/strapi';
import { SwitchLocale } from 'components/Buttons';
import { useMediaQueries } from '@hooks';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

const DrawerDesktopList = ({ onClose, type }) => {
  const { isMobile, isTablet } = useMediaQueries();
  const { t } = useTranslation();
  const [data, setData] = useState({
    stores: null,
    locations: null,
  });
  const [image, setImage] = useState(null);
  const [showCta, setShowCta] = useState(1);
  const sxAccordion = {
    '&.Mui-expanded': {
      color: '#da5f06',
      '& svg': {
        fill: '#da5f06',
      },
    },
    '& svg': {
      fill: '#30231F',
    },
  };
  const today = dayjs();
  const targetDate = dayjs('2025-07-31');
  const closingPeriod =
    today.isBefore(targetDate) || today.isSame(targetDate);
  const onFetchData = async () => {
    try {
      const { data: stores } = await getStrapiStores();
      const { data: img } = await getNavbarPhoto();
      setImage(
        img?.attributes?.img?.data?.attributes?.formats?.small?.url,
      );
      setData({ stores: [...stores] });
    } catch (error) {
      console.error('Error fetching filters:', error);
    }
  };
  useEffect(() => {
    onFetchData();
  }, []);
  return (
    <Box
      role="presentation"
      className="lg:flex relative w-full lg:justify-between lg:shadow-md "
    >
      {!(isTablet || isMobile) ? (
        <div className="flex flex-col w-full  pt-4">
          {type &&
            data[type]?.map((item) => {
              const { name, address, slug, category } =
                item?.attributes;

              const store_type = category?.data?.attributes?.slug;
              return (
                <div
                  key={item?.id}
                  className="h-full w-full flex items-center justify-between  hover:text-primary px-4 hover:bg-primary-100"
                  onMouseEnter={() => setShowCta(item?.id)}
                >
                  <div className="flex space-x-4 leading-none">
                    <p>{name}</p>
                    <i className="address">{address}</i>
                  </div>

                  {showCta === item?.id && (
                    <div className="flex space-x-4 mr-4">
                      <Button
                        variant="text"
                        className={classNames(
                          'leading-none',
                          'text-sm ',
                        )}
                      >
                        <Link
                          href={`/${type}/${store_type}/${slug}`}
                        >
                          <AddRounded className="mr-1" />
                          {t('buttons.discover')}
                        </Link>
                      </Button>{' '}
                      {!(
                        slug === 'ristorante-momento-neapolis' ||
                        (slug === 'ristorante-degli-scavi' &&
                          closingPeriod)
                      ) && (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classNames(
                            'leading-none',
                            'bg-primary text-sm hover:bg-primary-800',
                          )}
                        >
                          <Link href={`/booking?store=${slug}`}>
                            {t('buttons.book')}
                          </Link>
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      ) : (
        <div>
          <div className="body leading-none flex flex-col w-full ">
            <AccordionSummary className="px-2">
              <Link href={'/filosofia'}>
                <span>{t('navbar.philosophy')}</span>
              </Link>
            </AccordionSummary>
            {Object.keys(data).map((k) => (
              <Accordion sx={sxAccordion} key={k}>
                <AccordionSummary
                  className="px-2"
                  expandIcon={<ExpandMoreRounded />}
                >
                  {t(`navbar.locations`)}
                </AccordionSummary>
                <AccordionDetails className="px-2 py-2 space-y-2">
                  {data[k]?.length > 0 &&
                    data[k].map((item) => {
                      const { name, slug, category } =
                        item?.attributes;
                      const store_type =
                        category?.data?.attributes?.slug;
                      return (
                        <Link
                          key={item?.id}
                          href={`/stores/${store_type}/${slug}`}
                        >
                          <div className=" min-h-[32px]">
                            {name}
                          </div>
                        </Link>
                      );
                    })}
                </AccordionDetails>
              </Accordion>
            ))}
            <AccordionSummary className="px-2">
              <Link href={'/servizi'}>
                <span>{t('navbar.services')}</span>
              </Link>
            </AccordionSummary>
            <AccordionSummary className="px-2">
              <Link href={'/eventi'}>
                <p>{t('navbar.event_gallery')}</p>
              </Link>
            </AccordionSummary>
          </div>
        </div>
      )}

      {!(isTablet || isMobile) && (
        <div className="w-2/5 max-h-60">
          <Image
            fill
            src={
              image
                ? image
                : 'https://storage.googleapis.com/momento-bucket-strapi/homebar_0164c173b2/homebar_0164c173b2.jpg'
            }
            alt="ristorante-img"
            sizes="(max-width: 1200px) 50vw, 33vw"
            className="contain relative  "
          />
        </div>
      )}

      {!(isTablet || isMobile) && (
        <IconButton
          className="absolute top-2 right-2"
          onClick={() => {
            onClose();
          }}
        >
          <CloseRounded className="fill-neutral" />
        </IconButton>
      )}
      {isMobile && (
        <div className="w-full flex justify-center pb-4">
          <SwitchLocale />
        </div>
      )}
    </Box>
  );
};

export default DrawerDesktopList;
